const ptBR = {
  // Common
  save: 'Salvar',
  cancel: 'Cancelar',
  delete: 'Excluir',
  edit: 'Editar',
  add: 'Adicionar',
  search: 'Buscar',
  filter: 'Filtrar',
  export: 'Exportar',
  import: 'Importar',
  loading: 'Carregando...',
  noData: 'Sem dados',
  confirm: 'Confirmar',
  back: 'Voltar',
  close: 'Fechar',
  yes: 'Sim',
  no: 'Não',
  all: 'Todos',
  active: 'Ativo',
  inactive: 'Inativo',
  status: 'Status',
  actions: 'Ações',
  name: 'Nome',
  email: 'Email',
  password: 'Senha',
  value: 'Valor',
  date: 'Data',
  description: 'Descrição',
  type: 'Tipo',

  // Currency
  currency: 'BRL',
  currencyLocale: 'pt-BR',
  currencySymbol: 'R$',
  dateLocale: 'pt-BR',

  // Sidebar
  sidebar: {
    principal: 'Principal',
    dashboard: 'Dashboard',
    giftCards: 'Gift Cards',
    suppliers: 'Fornecedores',
    transactions: 'Transações',
    reports: 'Relatórios',
    admin: 'Administração',
    users: 'Usuários',
    adminPanel: 'Painel Admin',
    settings: 'Configurações',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    administrator: 'Administrador',
    operator: 'Operador',
    logout: 'Sair',
    help: 'Ajuda',
    blog: 'Blog',
    integrations: 'Integrações',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    goodMorning: 'Bom dia',
    goodAfternoon: 'Boa tarde',
    goodEvening: 'Boa noite',
    totalCards: 'Total de Cards',
    activeCards: 'Cards Ativos',
    availableBalance: 'Saldo Disponível',
    totalSavings: 'Economia Total',
    expiring: 'Expirando',
    noCardsExpiring: 'Nenhum card expirando',
    recentActivity: 'Atividades Recentes',
    last10: 'Últimas 10',
    noActivity: 'Nenhuma atividade',
    movementBySupplier: 'Movimentação por Fornecedor',
    bars: 'Barras',
    line: 'Linha',
    portfolioDistribution: 'Distribuição do Portfólio',
    summaryBySupplier: 'Resumo por Fornecedor',
    cards: 'cards',
    daysRemaining: 'dias restantes',
    expired: 'Expirado!',
    urgent: 'Urgente',
    monthlyComparison: 'Comparação Mensal',
    dailyBalance: 'Saldo Diário',
    purchases: 'Compras',
    uses: 'Usos',
    returns: 'Devoluções',
    adjustments: 'Ajustes',
    totalPurchases: 'Total Compras',
    totalUses: 'Total Usos',
    totalReturns: 'Total Devoluções',
    totalMoved: 'Total Movimentado',
    highest: 'Maior',
    lowest: 'Menor',
    variation: 'Variação',
    noPeriodData: 'Nenhum dado para o período',
    noDataAvailable: 'Nenhum dado disponível',
    noDataForMonth: 'Nenhum dado para o mês selecionado',
    discountSavings: 'Economia com Descontos',
    discountSavingsDesc: 'Total economizado comprando gift cards com desconto',
    cardsSaved: 'Cards Totalmente Usados',
    cardsSavedDesc: 'Cards totalmente usados antes da data de expiração',
  },

  // Transaction types
  transactionTypes: {
    COMPRA: 'Compra',
    USO: 'Uso',
    AJUSTE: 'Ajuste',
    RETURN: 'Devolução',
  },

  // Gift Card statuses
  giftCardStatus: {
    ATIVO: 'Ativo',
    PARCIAL: 'Parcial',
    ZERADO: 'Zerado',
    EXPIRADO: 'Expirado',
    CANCELADO: 'Cancelado',
    all: 'Todos os Status',
  },

  // Gift Cards page
  giftCards: {
    title: 'Gift Cards',
    subtitle: 'Gerencie seus gift cards',
    newCard: 'Novo Gift Card',
    code: 'Código',
    supplier: 'Fornecedor',
    initialValue: 'Valor Inicial',
    currentValue: 'Saldo Atual',
    discount: 'Desconto',
    paidValue: 'Valor Pago',
    cardNumber: 'Nº Cartão',
    pin: 'Senha',
    purchaseOrder: 'Ordem de Compra',
    purchaseDate: 'Data de Compra',
    expirationDate: 'Validade',
    buyer: 'Comprador',
    purchaseSite: 'Site de Compra',
    duplicateCardNumber: 'Ja existe um gift card com este numero de cartao na sua conta.',
    noCards: 'Nenhum gift card encontrado',
    grid: 'Grid',
    table: 'Tabela',
    usageValue: 'Valor do Uso',
    usedValue: 'Valor Utilizado',
    useAll: 'Usar Tudo',
    useFullBalance: 'Usar Saldo Total',
    giftCardValue: 'Valor do Gift Card',
    sortOptions: {
      availableFirst: 'Disponível primeiro',
      supplierAZ: 'Fornecedor A-Z',
      supplierZA: 'Fornecedor Z-A',
      highestValue: 'Maior valor',
      lowestValue: 'Menor valor',
      newest: 'Mais recente',
      oldest: 'Mais antigo',
    },
    bulkImport: 'Importação em Massa',
    bulkImportDesc: 'Importe múltiplos gift cards de uma vez a partir de um arquivo CSV.',
    downloadTemplate: 'Baixar Modelo CSV',
    downloadTemplateDesc: 'Baixe um arquivo CSV vazio com as colunas necessárias. Preencha com seus dados de gift cards e faça upload abaixo.',
    uploadCSV: 'Upload do Arquivo CSV',
    uploadCSVDesc: 'Selecione o arquivo CSV preenchido para importar seus gift cards.',
    importing: 'Importando...',
    importBtn: 'Importar Cards',
    imported: 'Importados',
    importError: 'Erro na importação',
    row: 'Linha',
    selectFile: 'Selecione um arquivo CSV',
    adminOnlyImport: 'Apenas administradores podem importar cards.',
    paidPlanOnly: 'Importação em massa está disponível nos planos Starter e Pro.',
    templateColumns: 'Colunas do modelo: fornecedor, site, comprador, valor, desconto, valor_pago, saldo, numero_cartao, pin, ordem_compra, data_compra, validade',
  },

  // Suppliers page
  suppliers: {
    title: 'Fornecedores',
    subtitle: 'Gerencie fornecedores de gift cards',
    mySuppliers: 'Meus Fornecedores',
    manageSuppliers: 'Gerenciar Fornecedores',
    customSuppliers: 'Fornecedores Custom',
    newSupplier: 'Novo Fornecedor',
    website: 'Website',
    defaultDiscount: 'Desconto Padrão',
    totalCards: 'Total Cards',
    activeCards: 'Cards Ativos',
    available: 'Disponível',
    invested: 'Investido',
    noSuppliers: 'Nenhum fornecedor encontrado',
    editSupplier: 'Editar Fornecedor',
    addSupplier: 'Adicionar Fornecedor',
    deactivate: 'Desativar',
    activate: 'Ativar',
  },

  // Transactions page
  transactions: {
    title: 'Transações',
    subtitle: 'Histórico de transações',
    newTransaction: 'Nova Transação',
    usage: 'Uso',
    adjustment: 'Ajuste',
    return: 'Devolução',
    value: 'Valor',
    orderNumber: 'Nº Ordem',
    user: 'Usuário',
    noTransactions: 'Nenhuma transação encontrada',
  },

  // Reports page
  reports: {
    title: 'Relatórios',
    subtitle: 'Análises e relatórios',
    bySupplier: 'Por Fornecedor',
    byBuyer: 'Por Comprador',
    exportCSV: 'Exportar CSV',
    totalFaceValue: 'Valor de Face Total',
    totalInvested: 'Total Investido',
    totalAvailable: 'Total Disponível',
    savings: 'Economia',
    avgDiscount: 'Desc. Médio',
  },

  // Users page
  users: {
    title: 'Usuários',
    subtitle: 'Gerencie usuários do sistema',
    newUser: 'Novo Usuário',
    inviteUser: 'Convidar Usuário',
    sendInvite: 'Enviar Convite',
    sending: 'Enviando...',
    inviteSent: 'Convite enviado! O usuário receberá um email para definir a senha.',
    inviteResent: 'Email de convite reenviado!',
    inviteHint: 'Um email será enviado com um link para definir a senha e acessar o painel.',
    resendInvite: 'Reenviar email de convite',
    role: 'Perfil',
    name: 'Nome',
    namePlaceholder: 'Nome completo',
    emailLabel: 'Email',
    activeLabel: 'Ativo',
    inactiveLabel: 'Inativo',
    totalUsers: 'Total de Usuários',
    registered: 'usuários registrados',
    administrators: 'Administradores',
    admin: 'Administrador',
    adminDesc: 'Acesso completo',
    operator: 'Operador',
    operatorDesc: 'Acesso padrão',
    noUsers: 'Nenhum usuário encontrado',
    editUser: 'Editar Usuário',
    deactivate: 'Desativar',
    activate: 'Ativar',
    deactivated: 'Usuário desativado',
    activated: 'Usuário ativado',
    pendingSetup: 'Aguardando configuração',
    cannotDeactivateSelf: 'Não é possível desativar seu próprio usuário',
    errorLoading: 'Erro ao carregar usuários',
    errorUpdating: 'Erro ao atualizar usuário',
  },

  // Settings page
  settings: {
    title: 'Configurações',
    subtitle: 'Gerenciamento da conta e plano',
    planUpgrade: 'Plano & Upgrade',
    paymentHistory: 'Histórico de Pagamentos',
    accountImport: 'Conta & Importação',
    currentPlan: 'Plano Atual',
    planUsage: 'Uso do Plano',
    users: 'Usuários',
    customSuppliers: 'Fornecedores Custom',
    perMonth: '/mês',
    free: 'Grátis',
    currentPlanBtn: 'Plano atual',
    upgrade: 'Upgrade',
    change: 'Mudar',
    processing: 'Processando...',
    activeSubscription: 'Assinatura Ativa',
    invoices: 'Faturas',
    noInvoices: 'Nenhuma fatura encontrada',
    invoiceDate: 'Data',
    invoiceDescription: 'Descrição',
    invoiceAmount: 'Valor',
    invoiceStatus: 'Status',
    invoicePeriod: 'Período',
    accountInfo: 'Informações da Conta',
    account: 'Conta',
    user: 'Usuário',
    profile: 'Perfil',
    plan: 'Plano',
    createdAt: 'Criada em',
    importCSV: 'Importar CSV',
    importDesc: 'Importe gift cards de um arquivo CSV. Colunas: fornecedor, site, comprador, valor, desconto, valor_pago, saldo, numero_cartao, pin, ordem_compra, data_compra, validade.',
    importBtn: 'Importar',
    importing: 'Importando...',
    adminOnly: 'Apenas administradores podem importar.',
    system: 'Sistema',
    version: 'Versão',
    language: 'Idioma',
    languageDesc: 'Escolha o idioma do sistema',
    confirmUpgrade: 'Confirma a mudança para o plano',
    currentLabel: 'ATUAL',
    unlimited: 'Ilimitado',
    manageSubscription: 'Gerenciar Assinatura',
    selectFile: 'Selecione um arquivo CSV',
    imported: 'Importados',
    row: 'Linha',
    loadError: 'Erro ao carregar dados da conta',
    loadHistoryError: 'Erro ao carregar histórico',
    upgradeError: 'Erro ao atualizar plano',
    importError: 'Erro na importação',
    portalError: 'Erro ao abrir portal de pagamento',
    timezone: 'Fuso Horário',
    timezoneDesc: 'Defina seu fuso horário preferido para exibição de datas e horários. Esta configuração é pessoal e salva no seu navegador.',
    currentTime: 'Hora atual',
    useStripeMsg: 'Use o Stripe Checkout para planos pagos.',
    changePassword: 'Alterar Senha',
    currentPassword: 'Senha Atual',
    newPassword: 'Nova Senha',
    confirmPassword: 'Confirmar Senha',
    updatePassword: 'Atualizar Senha',
    passwordChanged: 'Senha atualizada com sucesso',
    passwordChangeError: 'Erro ao alterar senha',
    passwordMismatch: 'As senhas não coincidem',
    passwordTooShort: 'A senha deve ter pelo menos 8 caracteres',
    changeEmail: 'Alterar Email',
    newEmail: 'Novo Email',
    confirmWithPassword: 'Confirmar com Senha',
    updateEmail: 'Atualizar Email',
    emailChanged: 'Email atualizado com sucesso',
    emailChangeError: 'Erro ao alterar email',
    changeEmailDesc: 'Insira seu novo email e senha atual para confirmar.',
    fillAllFields: 'Preencha todos os campos',
    security: 'Segurança',
    twoFactorTitle: 'Autenticação em Dois Fatores',
    currentMethod: 'Método atual',
    emailOtp: 'OTP por Email',
    totpEnabled: 'Google Authenticator (TOTP)',
    enableTotp: 'Ativar Google Authenticator',
    disableTotp: 'Desativar Google Authenticator',
    totpActive: 'Google Authenticator está ativo',
    scanQR: 'Escaneie este QR code com o Google Authenticator:',
    manualKey: 'Ou insira esta chave manualmente:',
    enterCode: 'Insira o código de 6 dígitos do app para verificar:',
    totpEnabledSuccess: 'TOTP ativado com sucesso!',
    totpDisabledSuccess: 'TOTP desativado. OTP por email será utilizado.',
    loginHistory: 'Histórico de Login',
    loginHistoryDesc: 'Atividade recente de login na sua conta',
    loginDate: 'Data',
    loginAction: 'Evento',
    loginIP: 'Endereço IP',
    loginDevice: 'Dispositivo',
    noLoginHistory: 'Nenhum histórico de login encontrado',
    sessions: 'Sessões Ativas',
    sessionsDesc: 'Gerencie suas sessões de login ativas',
    revokeAllSessions: 'Revogar Todas as Sessões',
    revokeAllSessionsConfirm: 'Isso desconectará você de todos os dispositivos. Continuar?',
    sessionsRevoked: 'Todas as sessões revogadas. Faça login novamente.',
    revokeError: 'Erro ao revogar sessões',
    support: 'Suporte',
    downgradeWarning: 'Aviso de Downgrade',
    downgradeWillLose: 'O downgrade pode afetar seus dados:',
    downgradeUsers: 'Usuários extras além do limite do plano serão desativados',
    downgradeCards: 'Você não poderá adicionar novos cards além do limite do plano',
    downgradeSuppliers: 'Fornecedores custom extras além do limite do plano serão desativados',
    confirmDowngrade: 'Eu entendo, fazer downgrade mesmo assim',
    cancelSubscription: 'Cancelar Assinatura',
    cancelSubscriptionDesc: 'Cancele sua assinatura paga. Seus dados serão preservados mas você será movido para o plano Free.',
    cancelSubscriptionBtn: 'Cancelar Assinatura',
    cancelReasonTitle: 'Sentimos muito em vê-lo ir. Qual o principal motivo?',
    cancelTooExpensive: 'Muito caro',
    cancelMissingFeatures: 'Faltam recursos que preciso',
    cancelFoundAlternative: 'Encontrei uma alternativa',
    cancelNoLongerNeeded: 'Não preciso mais',
    cancelJustTesting: 'Estava apenas testando',
    cancelOther: 'Outro',
    continueCancel: 'Continuar',
    nevermind: 'Deixa pra lá',
    offerTitle: 'Antes de ir...',
    feedbackTitle: 'Agradecemos seu feedback',
    keepSubscription: 'Manter minha assinatura',
    proceedCancel: 'Cancelar mesmo assim',
    goBack: 'Voltar',
    selectReason: 'Selecione um motivo',
    gladYouStayed: 'Que bom que você ficou!',
  },

  // Legal footer links
  legal: {
    terms: 'Termos de Uso',
    privacy: 'Política de Privacidade',
    cookies: 'Política de Cookies',
    cookieBanner: 'Usamos cookies para manter você conectado e, com seu consentimento, para melhorar o produto com análises anônimas.',
    acceptAll: 'Aceitar Todos',
    rejectOptional: 'Rejeitar Opcionais',
    managePreferences: 'Gerenciar Preferências',
    savePreferences: 'Salvar Preferências',
    essential: 'Essenciais',
    essentialDesc: 'Tokens de autenticação, idioma e tema. Necessários para o funcionamento do app.',
    analytics: 'Análises',
    analyticsDesc: 'Dados de uso anônimos via PostHog. Nos ajuda a entender quais recursos são mais usados. Nenhum dado pessoal é compartilhado.',
    alwaysOn: 'Sempre Ativo',
  },

  // Plan names
  plans: {
    FREE: { name: 'Free', desc: 'Para começar' },
    STARTER: { name: 'Starter', desc: 'Para equipes em crescimento' },
    PRO: { name: 'Pro', desc: 'Tudo ilimitado' },
  },

  // Status labels
  statusLabels: {
    active: 'Ativo',
    canceled: 'Cancelado',
    past_due: 'Atrasado',
    paid: 'Pago',
    pending: 'Pendente',
    failed: 'Falhou',
  },

  // Login
  login: {
    title: 'Bem-vindo ao CardLockr',
    subtitle: 'Acesse sua conta',
    email: 'Email',
    password: 'Senha',
    signIn: 'Entrar',
    signingIn: 'Entrando...',
    error: 'Email ou senha inválidos',
    forgotPassword: 'Esqueceu a senha?',
  },

  // Forgot Password
  forgotPassword: {
    title: 'Esqueceu sua senha?',
    subtitle: 'Insira seu email e enviaremos um link de redefinição.',
    send: 'Enviar Link',
    sending: 'Enviando...',
    success: 'Se uma conta com esse email existir, um link de redefinição foi enviado.',
    checkSpam: 'Verifique sua caixa de entrada (e pasta de spam) para o link.',
    backToLogin: 'Voltar ao Login',
  },

  // Reset Password
  resetPassword: {
    title: 'Redefinir Sua Senha',
    subtitle: 'Insira sua nova senha abaixo.',
    newPassword: 'Nova Senha',
    confirmPassword: 'Confirmar Senha',
    reset: 'Redefinir Senha',
    resetting: 'Redefinindo...',
    success: 'Senha redefinida com sucesso!',
    error: 'Link inválido ou expirado',
    mismatch: 'As senhas não coincidem',
    tooShort: 'A senha deve ter pelo menos 8 caracteres',
    invalidToken: 'Link Inválido',
    invalidTokenDesc: 'Este link de redefinição é inválido ou expirou.',
    requestNew: 'Solicitar Novo Link',
  },

  // 2FA Verification
  verify2FA: {
    title: 'Verifique Sua Identidade',
    emailSubtitle: 'Enviamos um código de 6 dígitos para seu email.',
    totpSubtitle: 'Insira o código do seu aplicativo autenticador.',
    verify: 'Verificar',
    verifying: 'Verificando...',
    resend: 'Reenviar Código',
    resending: 'Reenviando...',
    resent: 'Código reenviado! Verifique seu email.',
    invalidCode: 'Código de verificação inválido',
    didntReceive: 'Não recebeu o código?',
    sessionExpired: 'Sessão expirada. Faça login novamente.',
    trustDevice: 'Confiar neste dispositivo por 30 dias',
  },

  // Not Found page
  notFound: {
    title: 'Página Não Encontrada',
    message: 'A página que você procura não existe ou foi movida.',
    backHome: 'Ir para Início',
  },

  // Admin Panel
  adminPanel: {
    title: 'Painel Admin',
    accountOverview: 'Visão da Conta',
    plan: 'Plano',
    accountAge: 'Idade da Conta',
    days: 'dias',
    planExpires: 'Plano Expira',
    neverExpires: 'Nunca',
    usage: 'Uso',
    users: 'Usuários',
    giftCards: 'Gift Cards',
    customSuppliers: 'Fornecedores Custom',
    unlimited: 'Ilimitado',
    of: 'de',
    systemHealth: 'Saúde do Sistema',
    database: 'Banco de Dados',
    emailService: 'Serviço de Email',
    encryption: 'Criptografia',
    authentication: 'Autenticação',
    payments: 'Pagamentos',
    monitoring: 'Monitoramento',
    configured: 'Configurado',
    notConfigured: 'Não Configurado',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    uptime: 'Tempo Ativo',
    environment: 'Ambiente',
    securityOverview: 'Visão de Segurança',
    twoFAAdoption: 'Adoção 2FA',
    failedLogins24h: 'Logins Falhos (24h)',
    activeUsers: 'Usuários Ativos',
    totalUsers: 'Total de Usuários',
    teamMembers: 'Membros da Equipe',
    role: 'Papel',
    status: 'Status',
    twoFA: '2FA',
    cards: 'Cards',
    txns: 'Txns',
    joined: 'Entrou',
    enabled: 'Ativado',
    disabled: 'Desativado',
    recentLogins: 'Atividade de Login Recente',
    recentTransactions: 'Transações Recentes',
    noLogins: 'Nenhuma atividade de login ainda',
    noTransactions: 'Nenhuma transação ainda',
    cardsSummary: 'Resumo de Cards',
    totalValue: 'Valor Total',
    currentValue: 'Valor Atual',
    totalSavings: 'Economia Total',
    totalInvested: 'Total Investido',
    optional: 'opcional',
    emailOtp: 'Email OTP',
    allUsers: 'Todos os usuários',
    totpUsers: 'TOTP (Authenticator)',
  },

  // Onboarding Tour
  tour: {
    welcomeTitle: 'Bem-vindo ao CardLockr!',
    welcomeDesc: 'Sua plataforma para gerenciar gift cards com total controle. Vamos te mostrar tudo em poucos passos.',
    dashboardTitle: 'Dashboard',
    dashboardDesc: 'Seu painel de controle. Veja total de cards, saldo disponível, economia, gráficos e atividades recentes.',
    suppliersTitle: 'Fornecedores',
    suppliersDesc: 'Ative fornecedores populares como Amazon, Walmart, Target ou crie seus próprios fornecedores personalizados.',
    giftCardsTitle: 'Gift Cards',
    giftCardsDesc: 'Adicione, visualize e gerencie todos os seus gift cards. Acompanhe valores, descontos, validade e saldos.',
    transactionsTitle: 'Transações',
    transactionsDesc: 'Registre compras, usos, ajustes e devoluções. Mantenha um histórico completo de cada movimentação.',
    reportsTitle: 'Relatórios',
    reportsDesc: 'Analise seu portfólio por fornecedor ou comprador. Exporte dados em CSV para análise externa.',
    settingsTitle: 'Configurações',
    settingsDesc: 'Gerencie seu plano, importe cards via CSV, altere senha, ative 2FA e personalize sua experiência.',
    readyTitle: 'Tudo Pronto!',
    readyDesc: 'Comece ativando seus fornecedores e depois adicione seu primeiro gift card. Você pode acessar a Ajuda pelo menu lateral.',
    skip: 'Pular tour',
    next: 'Próximo',
    start: 'Vamos lá!',
  },

  // Help Center
  help: {
    title: 'Central de Ajuda',
    heroTitle: 'Como podemos ajudar?',
    heroDesc: 'Aprenda tudo sobre o CardLockr — do básico às funcionalidades avançadas. Escolha um tópico abaixo.',
    overview: 'Visão Geral',
    howTo: 'Como Fazer',
    features: 'Recursos',
    faq: 'Perguntas',
    shortcuts: 'Atalhos',

    whatIs: 'O que é o CardLockr?',
    whatIsDesc: 'CardLockr é uma plataforma segura de gerenciamento de gift cards feita para pessoas e equipes que compram gift cards com desconto. Pense nele como um cofre digital para seu portfólio de gift cards — ele mantém todos os números de cartão e PINs criptografados, acompanha saldos automaticamente conforme você usa, e mostra exatamente quanto você está economizando. Seja gerenciando 10 cards ou 10.000, o CardLockr ajuda você a se organizar e nunca perder o controle de um dólar.',
    overviewTip: 'Seu Dashboard é a primeira coisa que você vê ao fazer login. Ele mostra o valor total do portfólio, cards ativos, economia e cards expirando em breve — tudo em uma única tela.',
    mainFeatures: 'Principais Recursos',
    feat1Title: 'Gestão de Gift Cards',
    feat1Desc: 'Armazene, organize e acompanhe todos os seus gift cards em um só lugar. Números de cartão e PINs são criptografados com AES-256, padrão militar. Clique para copiar números e PINs instantaneamente.',
    feat2Title: 'Gestão de Fornecedores',
    feat2Desc: 'Escolha entre 30+ fornecedores pré-cadastrados (Walmart, Target, Amazon...) ou crie os seus. Defina uma taxa de desconto personalizada para cada fornecedor que preenche automaticamente ao criar cards.',
    feat3Title: 'Controle de Transações',
    feat3Desc: 'Registre cada compra, uso, ajuste e devolução. Saldos atualizam automaticamente e cada alteração é registrada no histórico de auditoria.',
    feat4Title: 'Relatórios e Análises',
    feat4Desc: 'Veja seu portfólio detalhado por fornecedor ou comprador. Acompanhe valor de face, valor investido, saldo disponível, economia total e desconto médio.',
    feat5Title: 'Segurança',
    feat5Desc: 'Criptografia AES-256 para todos os dados de cartão, autenticação de dois fatores (código por email + Google Authenticator), monitoramento de login e gestão de sessões.',
    feat6Title: 'Trabalho em Equipe',
    feat6Desc: 'Convide membros com perfis Admin ou Operador. Admins gerenciam tudo; Operadores podem adicionar/usar cards mas não alteram configurações da conta.',

    plans: 'Planos e Preços',
    plansDesc: 'O CardLockr oferece três planos. Comece grátis e faça upgrade conforme crescer:',
    freePlan: 'Free — $0/mês',
    freePlanDesc: 'Até 10 cards, 1 usuário e 3 fornecedores custom. Perfeito para experimentar o CardLockr e ver se atende seu fluxo de trabalho.',
    starterPlan: 'Starter — $9.90/mês',
    starterPlanDesc: 'Até 100 cards, 3 usuários, 10 fornecedores custom, importação CSV e relatórios básicos. Ótimo para equipes em crescimento.',
    proPlan: 'Pro — $24.90/mês',
    proPlanDesc: 'Cards, usuários e fornecedores ilimitados. Gráficos, exportação PDF, 2FA TOTP, acesso API, webhooks e suporte prioritário.',

    // How To — Getting Started
    howGettingStarted: 'Primeiros Passos (Configuração Inicial)',
    howGS1: 'Crie sua conta',
    howGS1d: 'Acesse cardlockr.com e clique em "Começar Grátis". Insira seu nome, email e senha. Você receberá um email de boas-vindas com dicas para aproveitar ao máximo o CardLockr.',
    howGS2: 'Ative seus fornecedores',
    howGS2d: 'Após fazer login, vá para a página de Fornecedores no menu lateral. Você verá 30+ fornecedores populares como Walmart, Target e Amazon. Clique no botão ao lado de cada fornecedor que você compra gift cards para ativá-lo.',
    howGS3: 'Adicione seu primeiro gift card',
    howGS3d: 'Vá em Gift Cards e clique no botão "+". Selecione o fornecedor, insira o valor do cartão, porcentagem de desconto, número do cartão e PIN. O CardLockr vai criptografar tudo e calcular quanto você economizou.',
    howGS4: 'Configure a segurança (recomendado)',
    howGS4d: 'Vá em Configurações > Segurança e ative a autenticação de dois fatores. Isso adiciona uma camada extra de proteção — toda vez que fizer login, você precisará inserir um código do seu email ou do app Google Authenticator.',
    howGSTip: 'Você pode começar a usar o CardLockr em menos de 2 minutos. Basta ativar seus fornecedores e adicionar seu primeiro card — todo o resto você pode explorar no seu ritmo.',

    // How To — Suppliers
    howSuppliers: 'Como configurar Fornecedores',
    howSuppliers1: 'Acesse a página de Fornecedores',
    howSuppliers1d: 'Clique em "Fornecedores" no menu lateral. Você verá duas seções: seus fornecedores ativos no topo e todos os disponíveis abaixo. A barra de busca ajuda a encontrar qualquer fornecedor rapidamente.',
    howSuppliers2: 'Ative fornecedores pré-cadastrados',
    howSuppliers2d: 'Encontre o fornecedor desejado (ex: Walmart, Target, Amazon) e clique no botão para ativá-lo. Uma vez ativo, ele aparecerá no dropdown de fornecedores quando você criar gift cards.',
    howSuppliers3: 'Crie fornecedores personalizados',
    howSuppliers3d: 'Se seu fornecedor não está na lista, clique em "Novo Fornecedor" para criar um personalizado. Insira o nome, website (opcional) e porcentagem de desconto padrão. Esse desconto será preenchido automaticamente ao criar cards desse fornecedor.',
    howSuppliers4: 'Defina um desconto personalizado para sua conta',
    howSuppliers4d: 'Para fornecedores pré-cadastrados, clique no botão de editar e defina "Meu Desconto" — isso sobrescreve o padrão do sistema para sua conta. Por exemplo, se o padrão do Walmart é 9% mas você consegue 7% consistentemente, defina seu desconto como 7% e ele será preenchido automaticamente toda vez.',
    howSuppliersTip: 'Descontos personalizados são mostrados com um badge amarelo e um asterisco (*) na lista de fornecedores para que você identifique facilmente quais customizou. Ao criar um novo gift card, seu desconto personalizado é usado automaticamente no lugar do padrão do sistema.',

    // How To — Gift Cards
    howCards: 'Como gerenciar Gift Cards',
    howCards1: 'Navegue pelos seus cards',
    howCards1d: 'Clique em "Gift Cards" no menu lateral para ver seu inventário completo. Use os filtros no topo para refinar por status (Ativo, Parcial, Zerado), fornecedor, ou busque por código/número do cartão. Você pode ordenar por qualquer coluna.',
    howCards2: 'Adicione um novo card (com preenchimento automático)',
    howCards2d: 'Clique no botão "+" para criar um novo card. Se você tiver um filtro de fornecedor ativo, o CardLockr preenche automaticamente o fornecedor e o desconto — sem precisar selecionar manualmente. Você também pode adicionar vários cards de uma vez usando o modo de entrada múltipla.',
    howCards3: 'Use um card (registre gastos)',
    howCards3d: 'Clique em qualquer card para abrir sua página de detalhes, depois clique em "Uso Rápido" para registrar quanto gastou. O saldo atualiza instantaneamente e a transação é registrada com data, valor e quem fez. Se o saldo chegar a $0, o card é marcado como "Zerado" automaticamente.',
    howCards4: 'Clique para copiar número e PIN',
    howCards4d: 'Precisa usar um card online? Clique diretamente no número do cartão na tabela e ele é copiado para sua área de transferência instantaneamente. Para PINs: clique uma vez para revelar o PIN escondido, depois clique novamente para copiar. Uma notificação rápida confirma a cópia.',
    howCards5: 'Acompanhe o status dos cards',
    howCards5d: 'Os cards têm rastreamento automático de status: Ativo (saldo completo), Parcial (saldo parcialmente usado), Zerado (saldo $0), Expirado ou Cancelado. As atualizações de status acontecem automaticamente quando você registra transações.',
    howCardsTip: 'Quando você tem um filtro de fornecedor ativo (ex: mostrando apenas cards Boscovs) e clica "+", o formulário de novo card preenche automaticamente com aquele fornecedor e sua taxa de desconto — ótimo para cadastrar vários cards do mesmo fornecedor rapidamente.',

    // How To — CSV Import
    howImport: 'Como importar cards via CSV',
    howImp1: 'Prepare seu arquivo CSV',
    howImp1d: 'Vá em Configurações > Conta & Importação e clique em "Baixar Template" para obter um CSV em branco com as colunas corretas: supplier, site, buyer, value, discount, paid_value, balance, card_number, pin, purchase_order, purchase_date, expiration_date. Preencha seus dados usando uma planilha.',
    howImp2: 'Formate seus dados corretamente',
    howImp2d: 'Certifique-se de que: nomes de fornecedores correspondam exatamente (ex: "Walmart" não "walmart gift card"), valores usem números sem símbolos de moeda (200 não $200), datas estejam no formato DD/MM ou DD/MM/AAAA, e PINs estejam como texto (não números) para preservar zeros à esquerda como "0632".',
    howImp3: 'Faça o upload e importe',
    howImp3d: 'Clique em "Upload CSV" e selecione seu arquivo. O CardLockr processa cada linha: combinando fornecedores, criptografando dados, verificando números duplicados e criando transações de compra automaticamente. Você verá um resumo mostrando quantos cards foram importados e quaisquer erros.',
    howImp4: 'Revise os resultados',
    howImp4d: 'Após a importação, verifique a página Gift Cards para confirmar que tudo está correto. Cada card importado tem uma transação de compra criada automaticamente. Se alguma linha teve erros (fornecedor não encontrado, número duplicado), eles são listados nos resultados para você corrigir e reimportar.',
    howImpTip: 'Importante: Se você editar o CSV no Excel, cuidado com PINs que começam com 0 (como "0632"). O Excel pode remover o zero e salvar como "632". Para evitar isso, formate a coluna PIN como "Texto" no Excel antes de inserir dados, ou use o Google Sheets que lida melhor com isso.',

    // How To — Transactions
    howTransactions: 'Como registrar Transações',
    howTx1: 'Veja o histórico de transações',
    howTx1d: 'Clique em "Transações" no menu lateral para ver uma lista cronológica de todas as movimentações. Cada transação mostra o código do card, tipo (Compra, Uso, Ajuste, Devolução), valor, quem fez e o saldo resultante.',
    howTx2: 'Registre uma nova transação',
    howTx2d: 'Você pode registrar transações de duas formas: (1) Na página de Transações, clique em "Nova Transação" e selecione o card, tipo e valor. (2) Na página de detalhes de um card, clique em "Uso Rápido" para o caminho mais rápido — basta inserir o valor e pronto.',
    howTx3: 'Filtre e entenda sua atividade',
    howTx3d: 'Use os filtros no topo para encontrar transações específicas por tipo, card, usuário ou período. Isso é útil para reconciliar compras ou entender padrões de uso.',
    howTxTip: 'Toda transação é imutável — uma vez registrada, faz parte do histórico de auditoria do card. Se cometer um erro, crie uma transação de Ajuste para corrigir o saldo ao invés de deletar.',

    // How To — Reports
    howReports: 'Como usar Relatórios',
    howRep1: 'Analise seu portfólio',
    howRep1d: 'Acesse "Relatórios" no menu lateral. A aba "Por Fornecedor" mostra valor de face total, valor investido, saldo disponível, economia total e desconto médio para cada fornecedor. A aba "Por Comprador" mostra as mesmas métricas agrupadas por quem comprou os cards.',
    howRep2: 'Exporte seus dados',
    howRep2d: 'Clique em "Exportar CSV" para baixar uma planilha com todos os dados. Isso é útil para contabilidade, registros fiscais ou compartilhar relatórios com membros da equipe que não têm acesso ao CardLockr.',
    howRepTip: 'Relatórios atualizam em tempo real. Verifique regularmente para identificar quais fornecedores oferecem os melhores descontos e onde a maior parte do valor do seu portfólio está concentrada.',

    // How To — Team
    howUsers: 'Como gerenciar sua Equipe',
    howUsr1: 'Veja sua equipe',
    howUsr1d: 'Clique em "Usuários" no menu lateral para ver todos os membros, seus perfis, último login e quantos cards cada um criou.',
    howUsr2: 'Convide novos membros',
    howUsr2d: 'Clique em "Convidar Usuário" e insira nome, email e perfil (Admin ou Operador). Eles receberão um email com instruções para configurar a conta e escolher uma senha. O link de convite é válido por 7 dias.',
    howUsr3: 'Entenda os perfis',
    howUsr3d: 'Admins têm acesso total: podem gerenciar cards, transações, fornecedores, usuários, configurações e cobrança. Operadores podem gerenciar cards e transações mas não podem convidar usuários, alterar configurações ou acessar cobrança — perfeito para membros da equipe que apenas precisam adicionar/usar cards.',
    howUsrTip: 'Cada plano tem um limite de usuários (Free: 1, Starter: 3, Pro: ilimitado). Se precisar de mais lugares, o upgrade é instantâneo em Configurações > Plano.',

    // How To — Security
    howSecurity: 'Como proteger sua Conta',
    howSec1: 'Ative a autenticação de dois fatores (2FA)',
    howSec1d: 'Vá em Configurações > Segurança. Por padrão, o CardLockr envia um código de 6 dígitos para seu email toda vez que você faz login. Para segurança ainda maior, ative o Google Authenticator (TOTP) — ele gera códigos no seu celular que mudam a cada 30 segundos, então mesmo que alguém tenha sua senha, não consegue fazer login sem seu celular.',
    howSec2: 'Monitore atividade de login',
    howSec2d: 'Em Configurações > Histórico de Login, você pode ver toda tentativa de login na sua conta — incluindo endereço IP, navegador, dispositivo e se foi bem-sucedida. Se vir um login que não reconhece, troque sua senha imediatamente.',
    howSec3: 'Revogue sessões suspeitas',
    howSec3d: 'Configurações > Sessões Ativas mostra todos os dispositivos logados. Se vir um dispositivo desconhecido, clique em "Revogar" para desconectá-lo imediatamente. Você também pode clicar em "Revogar Todas" para desconectar todos os dispositivos exceto o atual.',
    howSecTip: 'O CardLockr criptografa todos os números de cartão e PINs com AES-256-CBC em repouso. Mesmo que alguém acessasse o banco de dados diretamente, não conseguiria ler os dados dos seus cartões sem a chave de criptografia.',

    // Features tab
    allFeatures: 'Todos os Recursos',
    fDashTitle: 'Dashboard',
    fDashDesc: 'Visão em tempo real com total de cards, valor do portfólio, economia total e saldo ativo. Inclui gráficos de movimentação por fornecedor ao longo do tempo, além de lista de cards expirando em breve.',
    fCardsTitle: 'Gift Cards',
    fCardsDesc: 'Gestão completa com visualização em tabela, filtros por status/fornecedor/comprador, busca por código ou número, clique para copiar números e PINs, uso rápido para gastos rápidos e rastreamento automático de status.',
    fSuppTitle: 'Fornecedores',
    fSuppDesc: '30+ fornecedores pré-cadastrados com favicons. Crie fornecedores custom com suas próprias taxas de desconto. Defina descontos personalizados por conta que sobrescrevem os padrões e preenchem automaticamente ao criar cards.',
    fTxTitle: 'Transações',
    fTxDesc: 'Registre compras, usos, ajustes e devoluções. Histórico completo com filtros por tipo, card e usuário. Cada transação atualiza o saldo automaticamente e é registrada permanentemente.',
    fRepTitle: 'Relatórios',
    fRepDesc: 'Análises por fornecedor e comprador. Acompanhe valor de face, valor investido, saldo disponível, economia total e desconto médio. Exporte tudo em CSV para contabilidade.',
    fUsrTitle: 'Gestão de Equipe',
    fUsrDesc: 'Convide usuários por email com perfis Admin ou Operador. Acompanhe atividade por usuário. Limites por plano (Free: 1, Starter: 3, Pro: ilimitado).',
    fSetTitle: 'Configurações',
    fSetDesc: 'Gestão de plano, alteração de senha/email, fuso horário e idioma, importação/exportação CSV, gestão de sites de compra e exclusão de conta.',
    fSecTitle: 'Segurança',
    fSecDesc: 'Criptografia AES-256-CBC para números e PINs em repouso. Autenticação de dois fatores (OTP por email padrão + TOTP opcional via Google Authenticator). Histórico de login e gestão de sessões.',
    fImpTitle: 'Importação CSV',
    fImpDesc: 'Importe gift cards em massa via CSV com mapeamento automático de colunas. Lida com formatos de data, símbolos de moeda, detecção de duplicatas e preserva zeros à esquerda em PINs. Disponível nos planos Starter e Pro.',
    fPayTitle: 'Pagamentos',
    fPayDesc: 'Cobrança via Stripe com upgrades instantâneos, histórico de faturas e gestão automática de assinatura. Cancele quando quiser.',
    fCopyTitle: 'Clique para Copiar',
    fCopyDesc: 'Clique em qualquer número de cartão na tabela para copiar instantaneamente para sua área de transferência. Clique em um PIN para revelá-lo, depois clique novamente para copiar. Notificações rápidas confirmam cada cópia.',
    fDiscTitle: 'Descontos Personalizados',
    fDiscDesc: 'Sobrescreva o desconto padrão de qualquer fornecedor na sua conta. Sua taxa personalizada preenche automaticamente ao criar cards e aparece com badge amarelo na lista de fornecedores.',
    fLangTitle: 'Multi-idioma',
    fLangDesc: 'Interface completa em Inglês e Português (Brasil). Troque de idioma instantaneamente nas Configurações — todos os labels, datas e formatos de moeda atualizam imediatamente.',

    // FAQ
    faqTitle: 'Perguntas Frequentes',
    faqs: [
      { q: 'Meus dados de cartão estão seguros?', a: 'Com certeza. Segurança é nossa prioridade número um. Veja como protegemos seus dados:\n\n• Criptografia em repouso — Todo número de cartão e PIN é criptografado com AES-256-CBC antes de tocar no banco de dados. Este é o mesmo padrão de criptografia usado por bancos e governos.\n\n• Nunca armazenado em texto plano — Nós literalmente não conseguimos ver seus números de cartão ou PINs. Mesmo se nosso banco de dados fosse comprometido, invasores encontrariam apenas dados criptografados ilegíveis.\n\n• Autenticação de dois fatores — Todo login exige um código de verificação (email ou Google Authenticator), então uma senha roubada sozinha não é suficiente.\n\n• Isolamento por conta — Seus dados são completamente separados de outras contas. Toda consulta é filtrada pelo ID da sua conta.\n\n• Monitoramento de login — Você pode ver toda tentativa de login nas Configurações, incluindo IP, navegador e dispositivo, e revogar sessões suspeitas instantaneamente.\n\n• Limitação de tentativas — Ataques de força bruta são bloqueados automaticamente após muitas tentativas falhas.' },
      { q: 'Posso compartilhar acesso com minha equipe?', a: 'Sim! Vá em Usuários e clique em "Convidar Usuário". Você pode atribuir perfis Admin (acesso total) ou Operador (cards + transações apenas). Cada membro tem seu próprio login e toda atividade é rastreada por usuário.' },
      { q: 'Como importo cards existentes?', a: 'Vá em Configurações > Conta & Importação e baixe o template CSV. Preencha seus dados em uma planilha, depois faça upload do CSV. O CardLockr vai combinar fornecedores, criptografar dados, detectar duplicatas e criar transações de compra — tudo automaticamente.' },
      { q: 'O que acontece quando faço downgrade do plano?', a: 'Seus dados de cards são sempre preservados — nunca deletamos seus cards. Porém, usuários e fornecedores custom além do limite do novo plano serão desativados. Você pode reativá-los fazendo upgrade novamente.' },
      { q: 'Posso exportar meus dados?', a: 'Sim. A página de Relatórios tem botões "Exportar CSV" para relatórios por fornecedor e por comprador. Você também pode baixar um template CSV para backup ou migração.' },
      { q: 'Como funciona a autenticação de dois fatores?', a: 'Por padrão, um código de 6 dígitos é enviado para seu email toda vez que faz login. Para segurança reforçada, você pode ativar o Google Authenticator (TOTP) em Configurações > Segurança — ele usa seu celular para gerar códigos temporários que mudam a cada 30 segundos.' },
      { q: 'Quais navegadores são suportados?', a: 'CardLockr funciona em todos os navegadores modernos: Chrome, Firefox, Safari e Edge. Também funciona perfeitamente em navegadores mobile — sem precisar baixar app.' },
      { q: 'Como altero meu idioma?', a: 'Vá em Configurações > Sistema e selecione seu idioma preferido. O CardLockr está disponível em Inglês e Português (Brasil). A mudança é instantânea — todos os labels, datas e formatos de moeda atualizam imediatamente.' },
      { q: 'Como copio um número de cartão ou PIN?', a: 'Basta clicar no número do cartão na tabela de Gift Cards — ele é copiado para sua área de transferência instantaneamente. Para PINs: clique uma vez para revelar o PIN escondido, depois clique novamente para copiar. Uma notificação confirma a cópia.' },
      { q: 'O que é o campo "Meu Desconto" nos fornecedores?', a: 'Quando você edita um fornecedor pré-cadastrado, pode definir um desconto personalizado que sobrescreve o padrão do sistema para sua conta. Por exemplo, se o desconto padrão do Target é 11% mas você consegue 8% consistentemente, defina "Meu Desconto" como 8% e ele será preenchido automaticamente toda vez que adicionar um card Target.' },
      { q: 'Por que meu PIN perdeu um zero à esquerda na importação?', a: 'Isso geralmente acontece quando o CSV é aberto no Excel, que converte automaticamente textos que parecem números. Para evitar, formate a coluna PIN como "Texto" no Excel antes de inserir dados, ou use o Google Sheets que lida melhor com isso. O CardLockr preserva zeros à esquerda durante a importação desde que o arquivo CSV os contenha.' },
      { q: 'Posso excluir minha conta?', a: 'Sim. Vá em Configurações > Zona de Perigo e clique em "Excluir Conta". Isso excluirá permanentemente todos os seus dados incluindo cards, transações e contas de usuário. Esta ação não pode ser desfeita.' },
    ],

    // Shortcuts
    shortcutsTitle: 'Atalhos do Teclado',
    scSearch: 'Abrir busca / paleta de comandos',
    scSidebar: 'Recolher/expandir menu lateral',
    scClose: 'Fechar modais e painéis',

    // Click actions
    clickActionsTitle: 'Ações de Clique',
    caCardNum: 'Clique no Card #',
    caCardNumDesc: 'Copia instantaneamente o número completo do cartão para sua área de transferência',
    caPinHidden: 'Clique no PIN (oculto)',
    caPinHiddenDesc: 'Revela o PIN escondido para você ver',
    caPinRevealed: 'Clique no PIN (revelado)',
    caPinRevealedDesc: 'Copia o PIN para sua área de transferência',
  },

  // Trial banner
  trialBanner: ({ days }) => `Teste Pro — ${days} dia${days !== 1 ? 's' : ''} restante${days !== 1 ? 's' : ''}`,
  upgrade: 'Fazer Upgrade',
  trialBannerExpired: 'Seu teste Pro terminou',

  // Error Boundary
  errorBoundary: {
    title: 'Algo deu errado',
    message: 'Ocorreu um erro inesperado. Tente recarregar a página.',
    reload: 'Recarregar Página',
  },

  // Landing page
  landing: {
    trustedBy: 'Usado por {count}+ empresas gerenciando seus gift cards',
    mostPopular: 'Mais Popular',
    comparePlans: 'Comparar planos',
    feature: 'Recurso',
    giftCards: 'Gift Cards',
    suppliers: 'Fornecedores',
    teamMembers: 'Membros da Equipe',
    transactionHistory: 'Historico de Transacoes',
    csvImport: 'Importacao CSV',
    pdfExport: 'Exportacao PDF',
    reportsAnalytics: 'Relatorios e Analises',
    twoFaTotp: '2FA (TOTP)',
    prioritySupport: 'Suporte Prioritario',
    unlimited: 'Ilimitado',
    securedByStripe: 'Protegido pelo Stripe',
    aesEncryption: 'Criptografia AES 256-bit',
    gdprCompliant: 'Compativel com LGPD',
    moneyBackGuarantee: 'Garantia de 30 dias',
  },

  // Date format
  dateFormat: {
    short: 'DD/MM/YY',
    formatFn: (d, tz) => {
      if (!d) return '-';
      const date = new Date(d);
      if (tz) {
        try {
          const parts = new Intl.DateTimeFormat('pt-BR', {
            timeZone: tz, day: '2-digit', month: '2-digit', year: '2-digit',
          }).formatToParts(date);
          const get = (type) => (parts.find(p => p.type === type) || {}).value || '';
          return `${get('day')}/${get('month')}/${get('year')}`;
        } catch (e) { /* fallback below */ }
      }
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yy = String(date.getFullYear()).slice(-2);
      return `${dd}/${mm}/${yy}`;
    },
    formatTimeFn: (d, tz) => {
      if (!d) return '-';
      const date = new Date(d);
      if (tz) {
        try {
          const parts = new Intl.DateTimeFormat('pt-BR', {
            timeZone: tz, day: '2-digit', month: '2-digit', year: '2-digit',
            hour: '2-digit', minute: '2-digit', hour12: false,
          }).formatToParts(date);
          const get = (type) => (parts.find(p => p.type === type) || {}).value || '';
          return `${get('day')}/${get('month')}/${get('year')} ${get('hour')}:${get('minute')}`;
        } catch (e) { /* fallback below */ }
      }
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yy = String(date.getFullYear()).slice(-2);
      const hh = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      return `${dd}/${mm}/${yy} ${hh}:${min}`;
    },
  },

  // Enterprise
  enterprise: {
    title: 'Enterprise',
    subtitle: 'Para grandes equipes com necessidades personalizadas',
    customPricing: 'Personalizado',
    contactSales: 'Falar com Vendas',
    formTitle: 'Falar com Vendas',
    formSubtitle: 'Conte-nos sobre suas necessidades e criaremos um plano personalizado para sua equipe.',
    nameLabel: 'Nome',
    emailLabel: 'Email corporativo',
    companyLabel: 'Nome da empresa',
    teamSizeLabel: 'Tamanho da equipe',
    monthlyVolumeLabel: 'Volume mensal',
    messageLabel: 'Mensagem (opcional)',
    submit: 'Enviar consulta',
    submitting: 'Enviando...',
    thankYou: 'Obrigado!',
    thankYouMessage: 'Recebemos sua consulta e entraremos em contato em 24 horas.',
    features: ['Tudo do Pro', 'SSO (em breve)', 'Suporte dedicado', 'Onboarding personalizado', 'API de auditoria', 'Limites personalizados'],
  },

  // Blog
  blog: {
    blogTitle: 'Blog CardLockr',
    blogDescription: 'Dicas especializadas sobre rastreamento de gift cards, otimizacao de descontos e gestao de portfolio.',
    readingTime: 'de leitura',
    sharePost: 'Compartilhar este post',
    tryFree: 'Experimente CardLockr Gratis',
    writtenBy: 'Por',
    relatedPosts: 'Posts Relacionados',
    backToBlog: 'Voltar ao Blog',
    read: 'de leitura',
  },

  // Referrals
  referrals: {
    title: 'Indicacoes',
    yourReferralLink: 'Seu Link de Indicacao',
    copyLink: 'Copiar Link',
    linkCopied: 'Link de indicacao copiado!',
    shareAndEarn: 'Compartilhe e Ganhe',
    referralDescription: 'Convide amigos para o CardLockr. Quando eles se cadastrarem e assinarem, voces dois ganham 1 mes gratis!',
    pending: 'Pendente',
    qualified: 'Qualificado',
    rewarded: 'Recompensado',
    totalReferrals: 'Total de Indicacoes',
    linkClicks: 'Cliques no Link',
    signups: 'Cadastros',
    rewardsEarned: 'Recompensas Ganhas',
    customizeCode: 'Personalizar seu codigo',
    howItWorks: 'Como funciona',
    step1: 'Compartilhe seu link unico de indicacao',
    step2: 'Amigo se cadastra e assina um plano pago',
    step3: 'Voces dois ganham 1 mes gratis!',
  },

  // Growth & Sharing
  growth: {
    shareReport: 'Compartilhar Relatorio',
    generateLink: 'Gerar Link de Compartilhamento',
    shareExpires: 'Expira em 30 dias',
    noSensitiveData: 'Nenhum dado sensivel compartilhado: Numeros de cartao, PINs e emails pessoais nunca sao incluidos.',
    linkCopied: 'Link de compartilhamento copiado!',
    milestoneReached: 'Marco Alcancado!',
    shareAchievement: 'Compartilhar conquista',
    exportBranding: 'Marca nas Exportacoes',
    brandingDescription: 'Controla se "Gerado por CardLockr" aparece nos seus exports PDF e CSV.',
    showBranding: 'Mostrar marca CardLockr nas exportacoes',
    brandingPaidOnly: 'Remocao de marca disponivel nos planos pagos',
  },

  // Add-ons
  addons: {
    title: 'Complementos',
    description: 'Estenda seu plano com capacidade extra e funcionalidades.',
    purchase: 'Comprar',
    cancel: 'Cancelar',
    active: 'Ativo',
    availableOn: 'Disponivel no plano',
    perMonth: '/mes',
  },

  // Newsletter
  newsletter: 'Newsletter',
  subscribeNewsletter: 'Inscrever-se na newsletter',
  newsletterDescription: 'Receba dicas de gestao de gift cards semanalmente',
  checkEmailConfirm: 'Verifique seu email para confirmar!',
  alreadySubscribed: 'Voce ja esta inscrito!',
  confirmSubscription: 'Confirmar Inscricao',

  // Integrations & API
  integrations: 'Integrações',
  apiDocs: 'Documentação da API',
  apiDocumentation: 'Documentação da API',
  webhooks: 'Webhooks',
  comingSoon: 'Em Breve',
  joinWaitlist: 'Entrar na Lista de Espera',
  available: 'Disponível',
  apiKeyManagement: 'Gerenciamento de Chaves API',
  generateApiKey: 'Gerar Chave API',
  revokeKey: 'Revogar Chave',
  requestsToday: 'Requisições Hoje',
  apiKeyWarning: 'Mantenha sua chave API em segredo. Trate-a como uma senha.',

  // Dunning / Payment Issue
  paymentIssueBanner: 'Problema no pagamento — seu cartao foi recusado. Atualize seus dados de cobranca para evitar interrupcao do servico.',
  updateBilling: 'Atualizar Cobranca',
};

export default ptBR;
